import { gql } from '@apollo/client';
import { CAMPAIGN_FRAGMENT } from '../fragments/campaign.newsletter.graphql';

export const GET_CAMPAIGN_QUERY = gql`
  query GetCampaign($where: CampaignWhereUniqueInput!) {
    campaign(where: $where) {
      ...Campaign
    }
  }
  ${CAMPAIGN_FRAGMENT}
`;
